// email regex
export const REGEX_EMAIL_VALIDATION =
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
// password regex
export const PASSWORD_LENGTH_LIMITS = /^.{8,20}$/;
export const PASSWORD_CONTAINS_SPECIAL_CHARACTERS = /[\W_]+/;
export const PASSWORD_CONTAINS_MAYUS = /(?=.*[A-Z])/;
export const PASSWORD_CONTAINS_MINUS = /(?=.*[a-z])/;
